<template>
  <div class="home">
    <div class="top-content" />
    <div class="mid-content">正在学习使用中..................</div>
    <div class="bottom-content">
      <a href="http://beian.miit.gov.cn/" target="_blank">
        辽ICP备2023014137号-1
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
<style lang="scss" scoped>
.home {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .top-content {
    font-size: inherit;
  }
  .mid-content {
    font-size: 50px;
    font-weight: bold;
    flex: 1;
  }
  .bottom-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5px 0;
  }
}
</style>
